import { MaintainRecordServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies';
import dayjs from 'dayjs';
import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import SparepartsModal from './SparepartsModal.vue'
import EditModal from './EditModal.vue'

const mrsp = new MaintainRecordServiceProxy()
@Component({
  components: {
    SparepartsModal,
    EditModal
  }
})
export default class Alarm extends Vue {
  get columns() {
    return [
      {
        title: this.$t('actions'),
        dataIndex: 'actions',
        key: 'actions',
        width: 200,
        ellipsis: true,
        customRender: (sort, _record, index) => {
          return (
            <div style="">
              <a
                type="link"
                v-acl="page_maintenance_records_sp_record"
                onClick={(e) => {
                  e.stopPropagation();
                  this.view(_record);
                }}
              >
                {this.$t("page_plan_maintenance_spare_parts_record")}
              </a>
              {_record.recordStatus == 1 ? <a-divider type="vertical" /> : ""}
              {_record.recordStatus == 1 ? <a
                type="link"
                v-acl="page_maintenance_records_check_re"
                onClick={(e) => {
                  e.stopPropagation();
                  this.ok(_record);
                }}
              >
                {this.$t("ok")}
              </a> : ""}
              {_record.recordStatus == 1 ? <a-divider type="vertical" /> : ""}
              {_record.recordStatus == 1 ? <a
                type="link"
                v-acl="page_maintenance_records_edit_re"
                onClick={(e) => {
                  e.stopPropagation();
                  this.edit(_record);
                }}
              >
                {this.$t("edit")}
              </a> : ""}
            </div>
          );
        },
      },
      {
        title: this.$t('page_plan_maintenance_task_number'),
        dataIndex: 'recordCode',
        key: 'recordCode',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_application_No'),
        dataIndex: 'planCode',
        key: 'planCode',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_application_form_status'),
        dataIndex: 'recordStatusName',
        key: 'recordStatusName',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_equipment_coding'),
        dataIndex: 'deviceCode',
        key: 'deviceCode',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_equipment_name'),
        dataIndex: 'deviceName',
        key: 'deviceName',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_equipment_type'),
        dataIndex: 'deviceTypeName',
        key: 'deviceTypeName',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_program'),
        dataIndex: 'projectName',
        key: 'projectName',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_maintenance_start_time'),
        dataIndex: 'startTime',
        key: 'startTime',
        width: 200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
              { dayjs(value).format('YYYY-MM-DD HH:mm:ss') }
            </span>
          )
        },
      },
      {
        title: this.$t('page_plan_maintenance_maintenance_completion_time'),
        dataIndex: 'endTime',
        key: 'endTime',
        width: 200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
              { dayjs(value).format('YYYY-MM-DD HH:mm:ss') }
            </span>
          )
        },
      },
      {
        title: this.$t('page_plan_maintenance_extension_or_not'),
        dataIndex: 'isDelayName',
        key: 'isDelayName',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_delay_days'),
        dataIndex: 'delayDays',
        key: 'delayDays',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_reasons_for_delay'),
        dataIndex: 'delayReason',
        key: 'delayReason',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_person_in_charge_of_maintenance'),
        dataIndex: 'maintainUserName',
        key: 'maintainUserName',
        width: 200,
        ellipsis: true
      }
    ]
  };
  @Prop({ default: () => [] }) readonly data: Array<string>;
  @Prop({ default: () => [] }) readonly employeesList: Array<any>;
  @Prop({ default: "" }) readonly current: String;
  @Prop({ default: "" }) readonly pageSize: String;
  @Prop({ default: "" }) readonly total: String;
  @Prop({ default: false }) readonly loading: Boolean;
  @Prop({ default: 300 }) readonly height: Number;
  @Prop({ default: "" }) readonly selectId: String;
  @Prop({ default: () => [] }) readonly selectedRowKeys: Array<any>;

  spareVisible = false
  spareData = []
  editData = {}
  editVisible = false

  onSelectChange(selectedRowKeys,selectedRows) {
    this.$emit('onSelectChange', selectedRowKeys,selectedRows)
  }

  findUser(value) {
    const user = this.employeesList.find(res => res.id === value)
    return user ? user.name : ""
  }

  handleTableChange(current: number, pageSize: number) {
    const pager = {
      pageSize: pageSize,
      current: current
    }
    this.$emit('handleTableChange', pager)
  }

  showTotal(total) {
    return (this.$t('Total…items') as string).replace('{0}', total)
  }

  clickRow(record) {
    this.$emit('clickRow', record.id)
  }

  ok(record) {
    this.clickRow(record)
    mrsp.confirmMaintainRecord(record.id).then(() =>{
      this.$message.success( this.$t('page_plan_maintenance_success_yes'))
      this.$emit('reload')
    })
  }

  view(record) {
    this.clickRow(record)
    mrsp.queryMaintainRecordMaterialList(record.id).then(res => {
      this.spareData = res
      this.spareVisible = true
    })
  }

  spareClose(){
    this.spareVisible = false
  }
  
  editClose() {
    this.editVisible = false
  }

  edit(record){
    this.clickRow(record)
    mrsp.getMaintainRecord(record.id).then(res => {
      this.editData = res
      this.editVisible = true
    })
  }

  reload(){
    this.editVisible = false
    this.$emit('reload')
  }

  render() {
    return (
      <div>
        <ml-table
          pagination={false}
          columns={this.columns}
          dataSource={this.data}
          canChangeColWidth={true}
          bordered
          rowKey="id"
          selectRowKey={this.selectId}
          loading={this.loading}
          scroll={{ y: this.height, x: 2800 }}
          row-selection={{ selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange }}
          customRow={(record) => {
            return {
              on: { // 事件
                click: () => this.clickRow(record),       // 点击行
              },
            };
          }}
        >
        </ml-table>
        <a-pagination
          style="position:absolute;bottom: 4px;right: 20px"
          show-total={total => `${this.showTotal(total)}`}
          current={this.current}
          pageSize={this.pageSize}
          total={this.total}
          on-change={this.handleTableChange}
          on-showSizeChange={this.handleTableChange}
        />
        {
          this.spareVisible ?
            <spareparts-modal
              visible={this.spareVisible}
              dataSource={this.spareData}
              onClose={() => this.spareClose()}
            ></spareparts-modal> : null
        }
        {this.editVisible ? <edit-modal
          employeesList={this.employeesList}
          visible={this.editVisible}
          data={this.editData}
          onClose={() => this.editClose()}
          onReload={() => this.reload()}></edit-modal> : null }
      </div>
    )
  }
}